import Vue from 'vue'
import store from '@/store'

// import orderBy from 'lodash/orderBy'

const SET_LIST = (state, obj) => {
  if (obj !== undefined && obj.data !== undefined) {
    state.list = obj.data
    store.dispatch('setJoin',  obj.data)
    
  } else if (obj !== undefined) {
    state.list = obj
    store.dispatch('setJoin', obj)
  } else {
    state.list = []
  }
}

const SET_ONE = (state, obj) => {
  const { index, transacoesCompraVenda } = obj
  if (index > -1) {
    Vue.set(state.list, index, transacoesCompraVenda)
  } else {
    state.list.unshift(transacoesCompraVenda)
  }
  // state.list = (orderBy(state.list, ['usuario.vip', 'id'], ['desc', 'desc']))
}

const SET_COUNT_MESSAGENS = (state, obj) => {
  const { index, countMessages } = obj
  if (index > -1) {
    Vue.set(state.listCountMessagesChat, index, countMessages)
  } else {
    state.listCountMessagesChat.unshift(countMessages)
  }
}

const REMOVE_ONE = (state, obj) => {
  state.list.splice(obj.index, 1)
}

const SET_QUANTIDADE_TRANSACOES_ABERTAS = (state, obj) => {
  console.log('SET_QUANTIDADE_TRANSACOES_ABERTAS: ' + obj)
  if (obj === 0) {
    state.quantidadeTransacoesAbertas = -1
  } else {
    state.quantidadeTransacoesAbertas = obj
  }
}

const SET_QUANTIDADE_PAGINAS = (state, obj) => {
  // console.log('SET_QUANTIDADE_PAGINAS: ' + obj)
  state.quantidadeDePaginas = obj
}

export default {
  SET_LIST,
  SET_ONE,
  SET_COUNT_MESSAGENS,
  REMOVE_ONE,
  SET_QUANTIDADE_PAGINAS,
  SET_QUANTIDADE_TRANSACOES_ABERTAS
}



// WEBPACK FOOTER //
// ./src/features/admin/transacoesCompraVenda/store/mutations.js